import { Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeDialog } from '../../../../features/dialog';
import { enqueueErrorSnack, enqueueSuccessSnack } from '../../../../features/snackbar';
import { editAlert } from '../../../../features/alert';
import AlertForm from '../AlertForm';
import { validateProjectAlert } from '../../../../validator/project';
import { hasErrors } from '../../../../common';

const DIALOG_ID = "editAlert"
const DIALOG_WIDTH = "md"

function EditAlertDialog() {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const alerts = useSelector(state => state.alert.list);
    const alertId = useSelector((state) => state.dialog[DIALOG_ID])
    const show = !!alertId;
    const alert = alertId ? alerts.find(j => j.id === alertId) : null;
    const [errors] = useState({});
    const [form, setForm] = useState({});

    const save = e => {
        e && e.preventDefault() && e.stopPropagation();
        const errors = validateProjectAlert(form);
        if(hasErrors(errors)){
            return;
        }

        setLoading(true);
        dispatch(editAlert(form))
        .then(r => {
            dispatch(closeDialog(DIALOG_ID));
            dispatch(enqueueSuccessSnack("Alert saved"))    
        })
        .catch(e => {
            dispatch(enqueueErrorSnack("Error: " + e))    
        })
        .finally(() => {
            setLoading(false);
        })
    }

    const onClose = () => {
        dispatch(closeDialog(DIALOG_ID));
    }
    

    useEffect(() => {
        setForm(alert);
    }, [alert, alertId]);

    return <Dialog
        open={!!show}
        onClose={onClose}
        fullWidth
        maxWidth={DIALOG_WIDTH}
        
    >
        <form onSubmit={save}>
            <DialogTitle>
                Edit alert
            </DialogTitle>
            <DialogContent dividers={false}>
                <Box pr={3}>
                    <AlertForm form={form || alert} onChange={setForm} errors={errors} />
                </Box>
            </DialogContent>
            <DialogActions>
                {loading && <LinearProgress />}
                {!loading && <Box sx={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <Button sx={{marginRight: 2}} onClick={onClose} >Cancel</Button>
                    <Button variant="contained" color="secondary" type="submit">Save Alert</Button>
                </Box>}
            </DialogActions>
        </form>
    </Dialog>
}

export default EditAlertDialog;